import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormControlLabel, Radio, RadioGroup, Select, MenuItem } from '@material-ui/core';
import { Checkboxes } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { CredentialPicker } from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function GetMail({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const [mailAction, setmailAction] = useState(!action.fields?.action?.value && "")
    const label = 'CONTENT.CONFIGURATION-FORM.EMAIL.GET-MAIL.';
    const options = {
        checkbox0: { label: label + 'SECURE' },
        checkbox1: { label: label + 'WITHOUT-ATTACH' },
        checkbox2: { label: label + 'WITH-ATTACH' },
        radioButtons: {
            data: [{
                value: 'imap',
                label: label + 'IMAP'
            }, {
                value: 'pop',
                label: label + 'POP'
            }],
            defaultValue: 'imap'
        }
    }
    const [value, setValue] = useState();
    useEffect(() => {
        if (!action.fields.protocol) { action.fields.protocol = { type: 'RADIO', value: options.radioButtons.defaultValue }; }
        setValue(action.fields.protocol.value);
        if (!action.fields.action) {
            action.fields.action = { value: "" };
        } else {
            if (action.fields.action.value.length > 1) {
                setmailAction(action.fields.action.value);
            }
        }
    }, [action])

    const handleChange = (event) => {
        setValue(event.target.value);
        action.fields.protocol.value = event.target.value;
        if (event.target.value === "pop" && mailAction === "markasread") {
            action.fields.action.value = "";
            setmailAction("");
        }
    };
    const handleSelect = (event) => {
        setmailAction(event.target.value);
        action.fields.action.value = event.target.value;
    }
    return (
        <>
            <div className="form-element">
                {t(label + 'PROTOCOL')}
                <RadioGroup value={value ? value : options.radioButtons.defaultValue} onChange={handleChange}>
                    {options.radioButtons.data.map((item, itemI) =>
                        <FormControlLabel
                            key={itemI} value={item.value}
                            control={<Radio color="#C4C4C4" />}
                            label={t(item.label)}
                            labelPlacement="end"
                            size="small"
                        />
                    )}
                </RadioGroup>
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="secure" options={options.checkbox0} />
            </div>
            <div className="form-element">
                {t(label + 'HOST')}
                <TextInput action={action} inputName="host" variables={variables} setOpenVariable={setOpenVariable} isRequired fieldType="string" displayName={t(label + 'HOST')}/>
            </div>
            <div className="form-element">
                {t(label + 'PORT')}
                <TextInput action={action} inputName="port" variables={variables} setOpenVariable={setOpenVariable} isRequired fieldType="string" displayName={t(label + 'PORT')}/>
            </div>
            <div className="form-element">
                {t(label + 'MAIL')}
                <CredentialPicker action={action} inputName="mail" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            </div>
            <div className="form-element">
                {t(label + 'PASSWORD')}
                <CredentialPicker action={action} inputName="password" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            </div>
            {value === 'imap' &&
                <>
                    <div className="form-element">
                        {t(label + 'FROM')}
                        <TextInput action={action} inputName="from" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'FROM')}/>
                    </div>
                    <div className="form-element">
                        {t(label + 'CC')}
                        <TextInput action={action} inputName="cc" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'CC')}/>
                    </div>
                    <div className="form-element">
                        {t(label + 'SUBJECT-CONTAINS')}
                        <TextInput action={action} inputName="subjectContains" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'SUBJECT-CONTAINS')}/>
                    </div>
                    <div className="form-element">
                        {t(label + 'DESC-CONTAINS')}
                        <TextInput action={action} inputName="descriptionContains" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'DESC-CONTAINS')}/>
                    </div>
                    {/* <div className="form-element">
                        <Checkboxes action={action} inputName="withoutAttach" options={options.checkbox1} />
                        <Checkboxes action={action} inputName="withAttach" options={options.checkbox2} />
                    </div> */}

                </>
            }
            <div className="form-element">
                {t(label + "ACTION")}
                <Select
                    value={mailAction}
                    onChange={(e) => handleSelect(e)}
                    variant="outlined"
                    fullWidth
                    style={{ width: "90%" }}
                >
                    <MenuItem style={{ fontSize: 12 }} value=""><em>None</em></MenuItem>
                    {value === 'imap' && <MenuItem value="markasread">{t(label + 'MARK-AS-READ')}</MenuItem>}
                    <MenuItem value="delete">{t(label + 'DELETE')}</MenuItem>
                </Select>
            </div>
            <div className="form-element">
                {t(label + 'OUTPUT')}
                <VariablePicker action={action} inputName="output" variables={variables} setOpenVariable={setOpenVariable} filter="array" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
            </div>
        </>
    );
}
export default GetMail;